// This exists for backwards compatibility and should be removed
module.exports = [];